module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "Acknowledgments"
    }
  }, [_c('h1', {
    staticClass: "acknowledgments",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9780310412625_epub_toc_r1#acka"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "dcap"
  }, [_c('em', [_c('b', [_vm._v("F")])])]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OR ALL MY HELPERS ALONG THE WAY, FROM")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DELE AT THE")]), _vm._v(" start to Julia at the end, and for the love and support of my wife, Jackie, throughout, I give thanks and praise to the One who has supplied my every need.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14ed9d54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780310412625_epub_ack_r1.vue
// module id = 75
// module chunks = 0